import { SubscriptionStatus } from "@prisma/client";
import { TKey } from "@/app/translations/TKey";

export const PLAN_STATUS_LABEL: Record<SubscriptionStatus, TKey> = {
  [SubscriptionStatus.TRIALING]: TKey.PLAN_NAME_TRIAL,
  [SubscriptionStatus.ACTIVE]: TKey.PLAN_NAME_PRO,
  [SubscriptionStatus.PAST_DUE]: TKey.SUBSCRIPTION_STATUS_PAST_DUE,
  [SubscriptionStatus.CANCELED]: TKey.PLAN_NAME_NONE,
};
